import { Controller, useFormContext } from 'react-hook-form';

import { Dropdown, DropdownInputProps } from '@ui/components/Dropdown';
import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';

import { MINUTES_BEFORE_START_OPTIONS } from '@features/tournament/ui/components/TournamentSettings/constants';
import { TournamentEditFormValues } from '@features/tournament/ui/components/TournamentSettings/typings';

const OPTIONS: DropdownInputProps['options'] = [
  { value: '', label: 'Не закрывать регистрацию' },
  ...MINUTES_BEFORE_START_OPTIONS,
];

export function RegistrationCutoffInput() {
  const { control } = useFormContext<TournamentEditFormValues>();
  return (
    <FormRow>
      <FormLabel>Закрыть регистрацию</FormLabel>

      <FormInput>
        <Controller
          name="registrationClosedBeforeStartMinutes"
          control={control}
          defaultValue={null}
          render={({ field: { value, onChange, disabled } }) => {
            const onValidChange = (value: string) => {
              onChange(value ? parseInt(value, 10) : null);
            };
            return (
              <Dropdown
                options={OPTIONS}
                value={value?.toString()}
                onChange={onValidChange}
                disabled={disabled}
              />
            );
          }}
        />
      </FormInput>
    </FormRow>
  );
}
